import { useToggle } from '@bygghemmait/hooks';
import { RedDrawer } from 'components/Shared/Drawer';
import { Button } from 'components/Button';
import Markdown from 'components/Shared/Markdown';
import { useSelector } from 'react-redux';
import { selectPriceGuarantee } from 'views/ProductPage/selector';
import styles from './priceGuarantee.scss';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { GtmViewPriceMatchGuarantee } from 'store/googleTagManager/actions';

type PriceGuaranteeProps = {
  addMarginBottom?: boolean;
};

export const PriceGuarantee = ({ addMarginBottom = false }: PriceGuaranteeProps) => {
  const data = useSelector(selectPriceGuarantee);
  const [openDrawer, toggleOpenDrawer] = useToggle(false);
  const dispatch = useDispatch();

  const onDrawerToggle = () => {
    if (!openDrawer) dispatch(GtmViewPriceMatchGuarantee())
    toggleOpenDrawer();
  };

  if (!data) return null;
  const { title, buttonText, policyText, label } = data;
  return (
    <div className={cn(styles.wrapper, { [styles.marginBottom]: addMarginBottom })}>
      <span>{label}</span>
      <Button onClick={onDrawerToggle} appearance="link" type="button">
        {buttonText}
      </Button>
      <RedDrawer isOpen={openDrawer} onClose={onDrawerToggle} title={title}>
        <Markdown content={policyText} tag="p" className={styles.markdown} />
      </RedDrawer>
    </div>
  );
};
